import { axios } from '@/utils/request'

const PREFIX = '/device'

/**
 * 新增License配额
 * POST /device/device-license
 * @param {Object} data DeviceLicenseDto
 * @param {string} [data.endDate] 生效结束日期
 * @param {string} [data.id] id（编辑时必填）
 * @param {number} [data.quota] License配额数量
 * @param {string} [data.remark] 备注
 * @param {string} [data.startDate] 生效起始日期
 * @param {string} [data.tenantId] 租户ID
 * @param {number} [data.warningThreshold] 预警阈值(百分比,默认10)
 */
export function addDeviceLicense(data) {
  return axios({
    url: `${PREFIX}/device-license`,
    method: 'post',
    data,
  })
}

/**
 * 编辑License配额
 * PUT /device/device-license
 * @param {Object} data DeviceLicenseDto（编辑时 id 必填）
 */
export function updateDeviceLicense(data) {
  return axios({
    url: `${PREFIX}/device-license`,
    method: 'put',
    data,
  })
}

/**
 * License分页列表
 * GET /device/device-license/page
 * @param {Object} params
 * @param {string} [params.endDate] 有效期结束日期
 * @param {number} [params.page] 页码
 * @param {number} [params.pageSize] 每页条数
 * @param {string} [params.startDate] 有效期起始日期
 * @param {string} [params.status] EFFECTIVE / EXPIRING_SOON / USED_UP / EXPIRED
 * @param {string} [params.tenantId] 租户ID
 */
export function getDeviceLicensePage(params) {
  return axios({
    url: `${PREFIX}/device-license/page`,
    method: 'get',
    params,
  })
}

/**
 * 统计卡片数据
 * GET /device/device-license/statistics
 */
export function getDeviceLicenseStatistics() {
  return axios({
    url: `${PREFIX}/device-license/statistics`,
    method: 'get',
  })
}

/**
 * License详情
 * GET /device/device-license/{id}
 * @param {string} id
 */
export function getDeviceLicenseDetail(id) {
  return axios({
    url: `${PREFIX}/device-license/${id}`,
    method: 'get',
  })
}

/**
 * 删除License
 * DELETE /device/device-license/{id}
 * @param {string} id
 */
export function deleteDeviceLicense(id) {
  return axios({
    url: `${PREFIX}/device-license/${id}`,
    method: 'delete',
  })
}

export const deviceApi = {
  addDeviceLicense,
  updateDeviceLicense,
  getDeviceLicensePage,
  getDeviceLicenseStatistics,
  getDeviceLicenseDetail,
  deleteDeviceLicense,
}
